export const serviceProgressMixIn = {
  methods: {
    getStatusClass (statusName) {
      let className = ''
      switch (statusName) {
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__ON_GOING:
          className = 'mod1'
          break
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME_NOT_START:
          className = 'layer5'
          break
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__ENDING:
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME__END_STOP:
          className = 'layer6'
          break
        case this.emkt.EXPERIMENT_MODULES_STATUS_NAME_EXCEPTION:
          className = 'layer7'
          break
        default:
          className = ''
      }
      console.log('className', className)
      return className
    }
  }
}



// WEBPACK FOOTER //
// ./src/views_v_2.6/PrivateMixins/ProgressMixin.js